import React from 'react';

export const InfoFile = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="50"
    height="46"
    viewBox="0 0 50 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.67"
      d="M48.8119 19.9874C51.9995 25.2006 48.1953 33.3329 40.3149 38.1514C32.4345 42.9698 23.4621 42.6499 20.2745 37.4367C17.0869 32.2235 20.8911 24.0912 28.7715 19.2727C36.6518 14.4542 45.6242 14.7742 48.8119 19.9874Z"
      fill="#E8E6FF"
    />
    <g style={{ mixBlendMode: 'multiply' }} opacity="0.67">
      <path
        d="M40.0618 37.6878C36.2497 45.4719 24.4587 47.5212 13.726 42.265C2.99321 37.0088 -2.61707 26.4376 1.19505 18.6535C5.00717 10.8694 16.7981 8.82016 27.5309 14.0763C38.2636 19.3325 43.8739 29.9037 40.0618 37.6878Z"
        fill="#EFEEF8"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.2083 29.9999H34.7917C35.5971 29.9999 36.25 29.3283 36.25 28.4999V21.1271C36.25 18.7975 34.414 16.909 32.1491 16.909C28.988 16.909 26.4255 14.2732 26.4255 11.0218V10.4999C26.4255 8.01466 24.4667 5.99994 22.0504 5.99994H20.2083C19.4029 5.99994 18.75 6.67151 18.75 7.49994V28.4999C18.75 29.3283 19.4029 29.9999 20.2083 29.9999ZM20.2083 2.99994C17.7921 2.99994 15.8333 5.01465 15.8333 7.49994V28.4999C15.8333 30.9852 17.7921 32.9999 20.2083 32.9999H34.7917C37.2079 32.9999 39.1667 30.9852 39.1667 28.4999V21.1271C39.1667 17.1407 36.0248 13.909 32.1491 13.909C30.5989 13.909 29.3421 12.6164 29.3421 11.0218V10.4999C29.3421 6.3578 26.0775 2.99994 22.0504 2.99994H20.2083Z"
      fill="#5D54C0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.2083 30H34.7917C35.5971 30 36.25 29.3285 36.25 28.5V21.1917C36.25 18.0608 35.1921 15.0274 33.2573 12.6105L31.9031 10.9189C29.4099 7.80439 25.6932 6.00006 21.7709 6.00006H20.2083C19.4029 6.00006 18.75 6.67163 18.75 7.50006V28.5C18.75 29.3285 19.4029 30 20.2083 30ZM20.2083 3.00006C17.7921 3.00006 15.8333 5.01478 15.8333 7.50006V28.5C15.8333 30.9853 17.7921 33 20.2083 33H34.7917C37.2079 33 39.1667 30.9853 39.1667 28.5V21.1917C39.1667 17.3651 37.8736 13.6575 35.5089 10.7035L34.1547 9.01193C31.1075 5.20536 26.5648 3.00006 21.7709 3.00006H20.2083Z"
      fill="#5D54C0"
    />
  </svg>
);
